 import React from "react";

const DemoLectures = () => {
  const lectures = [
    {
      title: "Angle and its measurement Part 1 | 11th Maths",
      videoId: "ZaaFTyHYNVQ",
      teacher: "Prof. Vijay Yeole",
    },
    {
      title: "Trigonometry-1 | Lec-1 | Class 11th Mathss",
      videoId: "SmVKrUH1-cA",
      teacher: "Prof. Vijay Yeole",
    },
    {
      title: "Trigonometry-2 EX.3.1 Class 11th Maths",
      videoId: "8egn9F3ExGw",
      teacher: "Prof. Vijay Yeole",
    },
  ];

  return (
    <section className="py-20 bg-gradient-to-r from-orange-50 via-white to-orange-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Heading */}
        <div className="text-center mb-14">
          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-4 tracking-tight">
            Demo Lectures
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Experience high-quality teaching with real NEET-level explanations.
          </p>
        </div>

        {/* Lecture Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {lectures.map((lec, index) => (
            <a
              key={index}
              href={`https://www.youtube.com/watch?v=${lec.videoId}`}
              target="_blank"
              rel="noopener noreferrer"
              className="group bg-white rounded-2xl shadow-xl overflow-hidden 
                        transform transition-all duration-500 hover:scale-[1.05] 
                        hover:shadow-2xl border border-transparent 
                        hover:border-orange-400 hover:-translate-y-2"
            >
              <div className="relative">
                {/* Thumbnail */}
                <img
                  src={`https://img.youtube.com/vi/${lec.videoId}/hqdefault.jpg`}
                  alt={lec.title}
                  className="w-full h-52 object-cover"
                />

                {/* Play Button Overlay */}
                <div className="absolute inset-0 flex items-center justify-center bg-black/30 opacity-0 group-hover:opacity-100 transition">
                  <div className="w-14 h-14 bg-white rounded-full flex items-center justify-center shadow-xl">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="orange"
                      viewBox="0 0 24 24"
                      width="32"
                      height="32"
                    >
                      <path d="M8 5v14l11-7z" />
                    </svg>
                  </div>
                </div>
              </div>

              {/* Text */}
              <div className="p-5">
                <h4 className="font-bold text-gray-900 text-lg group-hover:text-orange-500 transition">
                  {lec.title}
                </h4>
                <p className="text-sm text-gray-600 mt-1">{lec.teacher}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DemoLectures;
